import React from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { NamedLink } from '../../components';
import { formatMoney } from '../../util/currency';
import { intlShape } from '../../util/reactIntl';
import { createSlug } from '../../util/urlHelpers';
import { propTypes } from '../../util/types';
import css from './ListingPage.module.css';

const FastReplyCard = props => {
  const { pick, intl, onClick } = props;
  const { listingId, name, replyHours, listing } = pick;
  const title = listing.attributes.title || name;
  const price = listing.attributes.price;
  const variants = listing.images?.[0]?.attributes?.variants || {};
  const image = variants['square-small'];
  const image2x = variants['square-small2x'];

  return (
    <li onClick={onClick}>
      <NamedLink
        className={css.fastReplyCard}
        name="ListingPage"
        params={{ id: listingId, slug: createSlug(title) }}
      >
        {image ? (
          <img
            className={css.fastReplyAvatar}
            src={image.url}
            srcSet={image2x ? `${image.url} 1x, ${image2x.url} 2x` : undefined}
            alt={title}
          />
        ) : (
          <span className={css.fastReplyAvatar} />
        )}
        <span className={css.fastReplyInfo}>
          <span className={css.fastReplyName}>{title}</span>
          <span className={css.fastReplyTime}>Usually replies in ~{replyHours} hours</span>
        </span>
        {price ? <span className={css.fastReplyPrice}>{formatMoney(intl, price)}</span> : null}
      </NamedLink>
    </li>
  );
};

const SectionEnquiriesPaused = props => {
  const { authorDisplayName, picks, testerNotified, intl, onBook, onPickClick } = props;

  return (
    <div className={css.enquiriesPaused}>
      <h2 className={css.enquiriesPausedTitle}>
        {authorDisplayName} isn't taking questions right now
      </h2>
      <p className={css.enquiriesPausedText}>
        You can still book {authorDisplayName} directly, and you're refunded automatically if the
        order isn't accepted.
      </p>
      {testerNotified ? (
        <p className={css.enquiriesPausedText}>
          We've let {authorDisplayName} know you wanted to ask something. If they reply, you'll
          see it in your inbox.
        </p>
      ) : null}
      <button type="button" className={css.sidePanelContinue} onClick={onBook}>
        Book {authorDisplayName}
      </button>

      {picks.length > 0 ? (
        <>
          <h3 className={css.fastReplyHeading}>Or ask a tester who replies fast</h3>
          <ul className={css.fastReplyList}>
            {picks.map(pick => (
              <FastReplyCard key={pick.listingId} pick={pick} intl={intl} onClick={onPickClick} />
            ))}
          </ul>
        </>
      ) : null}
    </div>
  );
};

SectionEnquiriesPaused.defaultProps = {
  picks: [],
  testerNotified: false,
};

SectionEnquiriesPaused.propTypes = {
  authorDisplayName: string.isRequired,
  testerNotified: bool,
  picks: arrayOf(
    shape({
      listingId: string.isRequired,
      name: string.isRequired,
      replyHours: number.isRequired,
      listing: propTypes.listing.isRequired,
    })
  ),
  intl: intlShape.isRequired,
  onBook: func.isRequired,
  onPickClick: func.isRequired,
};

export default SectionEnquiriesPaused;
